import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction, createGetSuccessAction, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { Flag, UpdatePayload } from "./flag.model";

const ACTION_PREFIX = "[Flag]";

export const FLAG_ACTION_TYPE = {
	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get All Success`,
	getAllFail: `${ACTION_PREFIX} Get All Fail`,
	update: `${ACTION_PREFIX} Update`,
	updateSuccess: `${ACTION_PREFIX} Update Success`,
	setCurrent: `${ACTION_PREFIX} Set Current ${SYNC_SUFFIX}`,
	appendRouteParams: `${ACTION_PREFIX} Append Route Params`,
};

/**
 * @deprecated [fabric-deprecated] - Use fabric FlagService from svc-content instead
 */
@Injectable({
	providedIn: "root",
})
export class FlagAction {
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getAllFlags_v2)" instead
	 */
	getAll(): Action {
		return createCachedGetAction({
			type: FLAG_ACTION_TYPE.getAll,
		});
	}

	getAllSuccess(flags: Flag[]): ActionWithPayload {
		return createGetSuccessAction({
			type: FLAG_ACTION_TYPE.getAllSuccess,
			payload: flags,
		});
	}

	update(payload: UpdatePayload): ActionWithPayload {
		return {
			type: FLAG_ACTION_TYPE.update,
			payload,
		};
	}

	updateSuccess(flags: Flag[]): ActionWithPayload {
		return {
			type: FLAG_ACTION_TYPE.updateSuccess,
			payload: flags,
		};
	}

	getAllFail(error: AppError): ActionWithPayload {
		return {
			type: FLAG_ACTION_TYPE.getAllFail,
			payload: error,
		};
	}

	setCurrent(flag: Flag): ActionWithPayload {
		return {
			type: FLAG_ACTION_TYPE.setCurrent,
			payload: flag,
		};
	}

	appendRouteParams(routeParams: string[]): ActionWithPayload {
		return {
			type: FLAG_ACTION_TYPE.appendRouteParams,
			payload: routeParams,
		};
	}
}
